import SignupForm from '../features/Auth/SignupForm';

const SignupPage = () => {
  return <SignupForm />;
};

export default SignupPage; 